export function customLog(str, type) {

	const tagStyle = 'display: inline-block ; color:#fff; border-radius:4px; padding:0.25em 0.5em;';
	const textStyle = 'color:#000; background: #fff6; border-top-right-radius: 4px; border-bottom-right-radius: 4px; padding:0.25em 0.5em;';

	// Function catalog
	const logTypes = {
		/* Line */
		low: () => console.log(`%c ${str}`, 'color:#8887;'),
		sep: () => {
			const strLen = str.length;
			const longueur = (60 - strLen) > 1 ? (60 - strLen) : 1;
			console.log(`%c   ${str}${' '.repeat(longueur)}`, 'background: #2592F6; color: #fff; padding:4px; border-radius:4px;');
		},
		title: () => {
			const strLen = str.length;
			const longueur = (60 - strLen) > 1 ? (60 - strLen) : 1;
			const pad = ' '.repeat(Math.floor(longueur / 2));
			console.log(`%c ${pad} ${str} ${pad}`, 'background: #92F6c5; color: #000; font-weight: bold; padding:20px 4px; border-radius:4px;');
		},
		subtitle: () => {
			const strLen = str.length;
			const longueur = (60 - strLen) > 1 ? (60 - strLen) : 1;
			const pad = ' '.repeat(Math.floor(longueur / 2));
			console.log(`%c ${pad} ${str} ${pad}`, 'background: #92F6c5; color: #000; font-weight: bold; padding:8px 4px; border-radius:4px;');
		},

		/* Tags */
		api: () => console.log(`%cAPI Call%c ${str}`, `${tagStyle} background:#8f04d0;`, textStyle),
		function: () => console.log(`%cFunction%c ${str}`, `${tagStyle} background:#db8436;`, textStyle),
		obsolete: () => console.log(`%cObsolete%c ${str}`, `${tagStyle} background:#aaaaaa;`, textStyle),
		alert: () => console.log(`%cAttention%c ${str}`, `${tagStyle} background:#cc3300;`, textStyle),
		warn: () => console.log(`%cAttention%c ${str}`, `${tagStyle} background:#ffaa00; color: #000;`, textStyle),
		success: () => console.log(`%cCool!%c ${str}`, `${tagStyle} background:#0c0;`, textStyle),
		wip: () => console.log(`%cWIP%c ${str}`, `background:#fc0; color:#000; ${tagStyle}`, textStyle),
		todo: () => console.log(`%cToDo%c ${str}`, `${tagStyle} background:#ed72e3;`, textStyle),
		info: () => console.log(`%cInfo%c ${str}`, `${tagStyle} background:#2592F6;`, textStyle),
		error: () => console.log(`%cERROR: ${str}`, `${tagStyle} background:#cc3300;`),
		dev: () => console.log(`%cDEV: ${str}`, `${tagStyle} background:#6600DD; color: #FFF;`),

		/* Puces */
		puce: () => console.log(`%c %c ${str}`, 'background: #fc0; padding:0 0.35em; border-radius: 50px;', 'color:#666;'),
		yellow: () => console.log(`%c %c ${str}`, 'background: #fc0; padding:0 0.35em; border-radius: 50px;', 'color:#666;'),
		green: () => console.log(`%c %c ${str}`, 'background: #0a0; padding:0 0.35em; border-radius: 50px;', 'color:#0a0;'),
		red: () => console.log(`%c %c ${str}`, 'background: #c00; padding:0 0.35em; border-radius: 50px;', 'color:#c00;'),
		blue: () => console.log(`%c %c ${str}`, 'background: #06f; padding:0 0.35em; border-radius: 50px;', 'color:#666;'),

		/* Presentational, others */
		table: () => console.table(str),
		group: () => {
			console.group('%cGROUP: ' + str, 'display: inline-block ; background:#ccf; color:#000; border-radius:4px; padding:0.25em 1em;');
		},
		groupEnd: () => {
			console.groupEnd();
			console.log("%c--- End group", 'display: inline-block ; background:#ccf; color:#000; border-radius:4px; padding:0.25em 1em;');
		},
	};

	const action = logTypes[type];
	if (action) {
		action();
	} else {
    	console.log(str); // fallback neutre
    }
}
